import { Component, HostListener } from '@angular/core';
import { RouterLink, RouterLinkActive, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { LogoComponent } from '../../components/logo/logo.component';
import { SupabaseService } from '../../../core/services/supabase.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  standalone: true,
  selector: 'app-navbar',
  imports: [RouterLink, RouterLinkActive, LogoComponent, CommonModule],
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent {
  isAuthenticated$: Observable<boolean>;
  currentUser$: Observable<any>;
  isDropdownOpen = false;

  constructor(
    private supabaseService: SupabaseService,
    private router: Router
  ) {
    this.isAuthenticated$ = this.supabaseService.getCurrentUser().pipe(
      map(user => {
        console.log('Navbar: Authentication state changed:', !!user);
        return !!user;
      })
    );
    this.currentUser$ = this.supabaseService.getCurrentUser();

    // Debug: Log current user on component init
    this.currentUser$.subscribe(user => {
      console.log('Navbar: Current user:', user);
    });
  }

  toggleDropdown(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    console.log('Toggle dropdown clicked! Current state:', this.isDropdownOpen);
    this.isDropdownOpen = !this.isDropdownOpen;
    console.log('New dropdown state:', this.isDropdownOpen);
  }

  closeDropdown(): void {
    this.isDropdownOpen = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    // Close dropdown if clicking outside
    if (this.isDropdownOpen) {
      this.isDropdownOpen = false;
    }
  }

  async signOut(event: Event): Promise<void> {
    event.preventDefault();
    this.closeDropdown();
    console.log('Sign out initiated...');

    try {
      console.log('Calling Supabase signOut...');
      await this.supabaseService.signOut();
      console.log('Supabase signOut completed successfully');

      // Navigate to home page after successful logout
      console.log('Navigating to home page...');
      this.router.navigate(['/']);
    } catch (error) {
      console.error('Error signing out:', error);
      // Still navigate to home even if there's an error
      this.router.navigate(['/']);
    }
  }

  getUserDisplayName(user: any): string {
    if (!user) return 'User';

    // Try to get full name from user_metadata (Google OAuth)
    if (user.user_metadata?.full_name) {
      return user.user_metadata.full_name;
    }

    // Try to get name from user_metadata (Google OAuth)
    if (user.user_metadata?.name) {
      return user.user_metadata.name;
    }

    // Try to get first and last name separately
    if (user.user_metadata?.first_name || user.user_metadata?.last_name) {
      const firstName = user.user_metadata?.first_name || '';
      const lastName = user.user_metadata?.last_name || '';
      return `${firstName} ${lastName}`.trim();
    }

    // Fallback to email if no name is available
    return user.email || 'User';
  }
}
